import { render, staticRenderFns } from "./UserAllocating.vue?vue&type=template&id=d2398a7e"
import script from "./UserAllocating.vue?vue&type=script&lang=js"
export * from "./UserAllocating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports